function formFunctions() {
	var $form = $('#' + globalVar.curSlide + ' form');

	if (!slides[globalVar.curSlide].form.dontGenerate) generateForm($form);

	var hasSubmit = !!$form.find('input[type=submit]').length;

	$form.addClass('form-style');
	$form.trigger('reset');

	if (!hasSubmit) $form.append('<input type="submit"/>');

	$form.on('submit.req-form', function (e) {
		e.preventDefault();
	});

	var inputs = $form.find('input');
	inputs.keyup(function () {
		var $this = $(this);
		var characters = $this.val().length;
		var maxLength = $this.attr('maxLength');
		var lastInput = $this.next().hasClass('checkbox');

		if (characters == maxLength && !lastInput) {
			$this.next().focus();
		}
	});
	inputs.keydown(function (e) {
		if ((e.which == 8 || e.which == 46) && $(this).val() == '') {
			$(this).prev('input').focus();
		}
	});
}

function checkForm() {
	var form = slides[globalVar.curSlide].form;
	var fields = form.fields;

	for (var key in fields) {
		var field = fields[key];
		var result = '';
		var inputs = $('#' + globalVar.curSlide + ' .' + field.class);
		var answer = field.answer;
		var caseSensitive = fields[key].caseSensitive;
		var userAnswer = '';

		if (field.answer) {
			if (field.type === 'checkbox') {
				var selectedAnswer = inputs.filter(':checked')[0];
				if (selectedAnswer) userAnswer = selectedAnswer.value;
			} else {
				inputs.each(function (i, input) {
					userAnswer += input.value;
				});
			}
			if (!caseSensitive) {
				answer = answer.toLowerCase();
				userAnswer = userAnswer.toLowerCase();
			}

			result = userAnswer === answer;

			if (form.debug) {
				console.log('User Answer: ', userAnswer, ' Actual Answer: ', answer);
				console.log('Result: ', result);
			}
			if (!result) {
				return false;
			}
		}
	}
	return true;
}

function validForm() {
	var valid = true;
	var requiredFields = $('#' + globalVar.curSlide)
		.find('input,textarea,select')
		.filter('[required]');
	requiredFields.each(function (i, field) {
		if (field.value === '') {
			valid = false;
			$('#' + globalVar.curSlide + ' form')
				.find('input[type=submit]')
				.trigger('click');
			return false;
		}
	});
	return valid;
}

function generateForm($form) {
	var fields = slides[globalVar.curSlide].form.fields;

	$form.html('');
	for (var key in fields) {
		var field = fields[key];

		var inputID = globalVar.curSlide.toLowerCase() + '-' + field.class;

		if (field.label) {
			var label = document.createElement('label');

			label.htmlFor = inputID;
			$(label).text(field.label);

			$form.append(label);
		}
		// establish type
		switch (field.type) {
			case 'checkbox':
				field.options.forEach(function (option) {
					var optionLabel = option.toLowerCase().split(' ').join('-');
					var radio = document.createElement('input');
					var radioLabel = document.createElement('label');

					radioLabel.htmlFor = field.class + '-' + optionLabel;
					$(radioLabel).addClass(field.class + '-container radio-container');

					radio.setAttribute('type', 'radio');
					radio.id = field.class + '-' + optionLabel;
					radio.required = !field.optional;
					radio.name = field.class;
					radio.value = option;
					$(radio).addClass(field.class);

					$form.append(radioLabel);
					$(radioLabel).append(radio);

					if (field.style) {
						$(radio).addClass('hide-radio');
						var customCheck = document.createElement('span');
						$(customCheck).addClass('custom-checkmark');
						$(radioLabel).append(customCheck);

						switch (field.style) {
							case 'x':
								$(radioLabel).addClass(field.class + '-style x-style');
								break;
							case 'dot':
								$(radioLabel).addClass(field.class + '-style dot-style');
								break;
							case 'button':
								$(radioLabel).addClass(field.class + '-style button-style');
								break;
						}
					}

					if (field.labels) {
						var sLabel = document.createElement('span');

						$(sLabel).addClass(field.class + '-option-label');
						$(sLabel).text(option);

						$(radioLabel).append(sLabel);
					}
				});
				break;
			case 'dropdown':
				var dropdown = document.createElement('select');
				var placeholder = field.placeholder;
				dropdown.id = inputID;
				dropdown.required = !field.optional;
				$(dropdown).addClass(field.class + ' ' + field.class + '-style');
				$(dropdown).append('<option value="">' + (placeholder ? placeholder : 'Select One') + '</option>');
				field.options.forEach(function (option) {
					$(dropdown).append('<option value="' + option + '">' + option + '</option>');
				});
				if (field.hideIcon) $(dropdown).addClass('hidden-icon');
				$form.append(dropdown);
				break;
			case 'date':
				var dateInput = document.createElement('input');

				dateInput.setAttribute('type', 'date');

				dateInput.required = !field.optional;
				dateInput.id = inputID;
				if (field.min) dateInput.min = field.min;
				if (field.max) dateInput.max = field.max;
				if (field.hideIcon) $(dateInput).addClass('hidden-icon');
				$(dateInput).addClass(field.class + ' ' + field.class + '-style');

				$form.append(dateInput);
				break;
			case 'number':
				var numberInput = document.createElement('input');

				numberInput.setAttribute('type', 'number');

				numberInput.required = !field.optional;
				numberInput.id = inputID;
				if (field.min) numberInput.min = field.min;
				if (field.max) numberInput.max = field.max;
				if (field.step) numberInput.step = field.step;
				if (field.hideIcon) $(numberInput).addClass('hidden-icon');
				if (field.placeholder) numberInput.placeholder = field.placeholder;
				$(numberInput).addClass(field.class + ' ' + field.class + '-style');

				$form.append(numberInput);
				break;
			default:
				// create field
				if (!field.separate) {
					var textInput = document.createElement('input');

					textInput.setAttribute('type', 'text');
					textInput.required = !field.optional;
					textInput.id = inputID;
					if (field.maxLength) textInput.maxLength = field.maxLength;
					if (field.placeholder) textInput.placeholder = field.placeholder;
					$(textInput).addClass(field.class + ' ' + field.class + '-style');

					$form.append(textInput);
				} else {
					// separate fields per letter
					for (var i = 0; i < field.answer.length; i++) {
						var textInput = document.createElement('input');

						if (!i) textInput.id = inputID;
						textInput.setAttribute('type', 'text');
						textInput.maxLength = 1;
						textInput.required = !field.optional;
						$(textInput).addClass(
							field.class +
								' ' +
								field.class +
								'-style ' +
								field.class +
								'-' +
								(i + 1) +
								'-style separated'
						);

						$form.append(textInput);
					}
				}
				break;
		}
	}
}
